const parseJsonString = (str) => {
	if (typeof str !== `string`) {
		return undefined;
	}
	try {
		return JSON.parse(str);
	} catch {
		return undefined;
	}
};

export default parseJsonString;
